/* eslint-disable jira/import-whitelist */
// eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.

import { CONSOLIDATION_STATE_RESOURCE_TYPE } from '@jira/router-resources__eoc-tenant-info/src/consolidationStateResourceType.constants.tsx';
import type { TenantInfo } from '@jira/router-resources__eoc-tenant-info/src/TenantInfo.types.tsx';
import { fetch } from '@atlassian/eoc-fetch';

import { checkIsTransitioning } from '@atlassian/jira-eoc-tenant-info/src/controllers/utils.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';

type ApiCheckResponse = {
	data: boolean;
};

const CHECK_API_KEY_RESOURCE_TYPE = 'EOC_CHECK_API_KEY';

const fetchCheckApiKeyManagementKeys = async (
	accountId: string | null,
	isSiteAdmin: boolean,
	isTransitioning: boolean,
	appPermissions?: {
		hasServiceDeskAccess: boolean;
	},
): Promise<boolean> => {
	if (
		!isTransitioning ||
		!isSiteAdmin ||
		(appPermissions && appPermissions.hasServiceDeskAccess === false)
	) {
		return Promise.resolve(false);
	}

	return fetch<ApiCheckResponse>(`/api-keys/web/check?accountId=${accountId}`).then(
		({ data }) => data,
	);
};

// eslint-disable-next-line jira/router/no-daisy-chaining-resources
const resource = createResource<boolean>({
	type: CHECK_API_KEY_RESOURCE_TYPE,
	getKey: () => 'check-api-key-management-keys',
	getData: async (
		{ dependencies },
		{ tenantContext: { atlassianAccountId, appPermissions, isSiteAdmin } },
	) => {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		const tenantInfo = (await dependencies[CONSOLIDATION_STATE_RESOURCE_TYPE]
			?.promise) as TenantInfo;
		const isTransitioning = checkIsTransitioning(tenantInfo);

		return fetchCheckApiKeyManagementKeys(
			atlassianAccountId,
			isSiteAdmin,
			isTransitioning,
			appPermissions,
		);
	},
	maxAge: Infinity,
	isBrowserOnly: true,
	depends: [CONSOLIDATION_STATE_RESOURCE_TYPE],
	isCritical: true,
});

export const checkApiKeyManagementKeysResource = (): RouteResource<boolean> => resource;
